import React, { useState } from "react";
import { Button, Tooltip, Modal, Spin } from "antd";
import { Row, Col } from "reactstrap";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import {
  PlusCircleTwoTone,
  EditOutlined,
  DeleteOutlined,
  DropboxCircleFilled,
} from "@ant-design/icons";
import "../../utils/style.css";
import { deletePaimentAccount } from "../../../payements/services/paymentApi";
import toast from "react-hot-toast";
import { useQueryClient } from "react-query";
import SelectAccountTypeModal from "../accountType";
import AccountForm from "./accountForm";

const Accounts = ({
  accounts = [],
  isLoadAccount,
  isErrorAcc,
  errorAcc,
  onSuccessMobile,
}) => {
   const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const [modalOpen, setModalOpen] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [selectedAcc, setSelectedAcc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 10;
  const queryClient = useQueryClient();

  const openAddModal = () => {
    setSelectedAcc(null);
    setModalOpen(true);
  };

  const handleEdit = (acc) => {
    setSelectedAcc(acc);
    setModalEdit(true);
  };

  const confirmDelete = (acc) => {
    toast.success('Pas de suppression possible pour le moment, contactez le support.')
    // Modal.confirm({
    //   title: "Confirmer la suppression",
    //   content: `Voulez-vous vraiment supprimer ce compte (${acc.prefix} ${acc.phone}) ?`,
    //   okText: "Oui",
    //   okType: "danger",
    //   cancelText: "Non",
    //   onOk: async () => {
    //     try {
    //       await deletePaimentAccount(acc?.id);
    //       await queryClient.invalidateQueries("accounts");
    //       toast.success("Compte supprimé avec succès ✅");
    //     } catch (error) {
    //       toast.error("Erreur lors de la suppression du compte");
    //     }
    //   },
    // });
  };

  const filteredAccounts = accounts
    .filter((acc) => {
      const fullText = `${acc.phone} ${acc.prefix} ${acc.paymentGateway}`.toLowerCase();
      return fullText.includes(searchTerm.toLowerCase());
    })
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));


  const paginatedAccounts = filteredAccounts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div>
      <Row>
        <Col lg={6} className="mb-2">
          <Button
            type="primary"
            className="btn-confirm-reversement "
            onClick={openAddModal}
            disabled={currentUser?.adminImpersonation}
          >
            <PlusCircleTwoTone className="me-1" /> 
            {currentUser?.adminImpersonation ? 'Pas autorisé à ajouter un compte' : 'Ajouter un compte de versement'}
          </Button>
        </Col>
        <Col lg={6} className="text-end">
          <input
            type="text"
            className="form-control"
            placeholder="🔎 Rechercher ..."
            value={searchTerm}
            onChange={(e) => {
              setCurrentPage(1);
              setSearchTerm(e.target.value);
            }}
          />
        </Col>
      </Row>

      <div className="add-rever-card">
        <Row className="mb-4">
          {isLoadAccount ? (
            <Col lg={12} className="text-center my-5">
              Chargement des comptes en cours... <Spin />
            </Col>
          ) : isErrorAcc ? (
            <Col lg={12} className="text-center text-danger my-5">
              Une erreur est survenue, contactez le support
                {/* {typeof errorAcc === "string"
                  ? errorAcc
                  : errorAcc instanceof Error
                  ? errorAcc.message
                  : JSON.stringify(errorAcc)} */}
            </Col>
          ) : filteredAccounts.length === 0 ? (
            <Col lg={12}>
              <div className="no-account-message text-muted text-center py-5">
                <DropboxCircleFilled style={{ fontSize: 48, color: "#D0D3DC", marginBottom: 12 }} />
                <p className="fw-semibold mb-0">Aucun compte trouvé</p>
                <small className="text-muted">
                  Essayez un autre numéro ou ajoutez un compte.
                </small>
              </div>
            </Col>
          ) : (
            paginatedAccounts.map((acc, index) => (
              <Col lg={12} key={index} className="mb-2">
                <div className="account-card p-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="text-muted">{acc.ownerFullName || "-"}</div>
                    <div className="text-muted">{acc.paymentMethod || "-"}</div>
                    <div className="fw-bold">
                      {
                      
                        (() => {
                          const phone = parsePhoneNumberFromString(acc.phoneNumber, acc.countryCode);
                          return <span>{phone ? phone.formatInternational() : "Pas de numéro"}</span>;
                        })()
                      }
                    </div>
                    <div className="d-flex gap-2">
                      <Tooltip title="Modifier">
                        <div
                          className="action-icon edit-icon"
                          onClick={() => handleEdit(acc)}
                        >
                          <EditOutlined />
                        </div>
                      </Tooltip>
                      <Tooltip title="Supprimer">
                        <div
                          className="action-icon delete-icon"
                          onClick={() => confirmDelete(acc)}
                        >
                          <DeleteOutlined />
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </Col>
            ))
          )}

          {filteredAccounts.length > itemsPerPage && !isLoadAccount && !isErrorAcc && (
            <div className="d-flex justify-content-end mt-3">
              <Button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
                className="me-2"
              >
                Précédent
              </Button>
              <Button
                disabled={currentPage * itemsPerPage >= filteredAccounts.length}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Suivant
              </Button>
            </div>
          )}
        </Row>

        <SelectAccountTypeModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          isLoading={loading}
          selectedPaymentAccount={selectedAcc}
        />

        <Modal
          open={modalEdit}
          onCancel={() => setModalEdit(false)}
          footer={null}
          destroyOnClose
        >
          <AccountForm
            selectedPaymentAccount={selectedAcc}
            isEdit={true}
            onSuccessMobile={onSuccessMobile}
            onClose={() => setModalEdit(false)}
          />
        </Modal>
      </div>
    </div>
  );
};

export default Accounts;
